import DashboardBox from './_DashboardBox';

export default DashboardBox;
